import './About.css';

const About = () => {
  return (
    <div className='main-aboutpage py-5' style={{ minHeight: '100vh' }}>
      <div className="container">
        <h2 className="fs-2 head-font-bold text-center text-brand-secondary text-uppercase">About us</h2>
        <p className="mb-3 fs-lg">Pentadeco, incorporated in 2022, is a dynamic home decor & kitchen and dinning brand dedicated to transforming everyday spaces with thoughtfully designed, customizable decor products. We believe that your home should reflect your personality, which is why we specialize in delivering unique, aesthetically appealing, and functional pieces that add a personal touch to your interiors.</p>
        <p className="mb-0 fs-lg">At Pentadeco, we focus on innovation, craftsmanship, and customer satisfaction. Each product is designed with attention to detail, blending style with utility to cater to modern lifestyle needs. Whether it's a striking wall accent, an elegant table piece, or an inspiring home organizer, our designs are made to complement diverse tastes and living spaces.</p>

        <div className="other-links-wrapper mt-5">
          <h2 className="fs-4 text-brand-primary head-font-bold">We are proud to offer our products across Leading Online Marketplaces</h2>
          <div className="row mt-4">
            <div className="col-md-3 p-1 col-6">
              <a href="https://www.amazon.in/stores/PENTADECO/page/5CBF87B7-1BD3-4475-B3A1-1CF4DF594BAD?lp_asin=B0CR3P8MVX&ref_=ast_bln" className="nav-link">
                <div className='border border-brand-primary rounded-3' style={{ width: '100%', aspectRatio: '3/1', objectFit: 'contain', padding: '15px' }}>
                  <img src="/assets/brand-amazon.webp" alt="amazon" className='w-100' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                </div>
              </a>
            </div>
            <div className="col-md-3 p-1 col-6">
              <a href="https://www.nykaa.com/brands/pentadeco/c/58333" className="nav-link">
                <div className='border border-brand-primary rounded-3' style={{ width: '100%', aspectRatio: '3/1', objectFit: 'contain', padding: '15px' }}>
                  <img src="/assets/brand-nykaa.png" alt="naykaa" className='w-100' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                </div>
              </a>
            </div>
            <div className="col-md-3 p-1 col-6">
              <a href="https://www.myntra.com/pentadeco?p=1" className="nav-link">
                <div className='border border-brand-primary rounded-3' style={{ width: '100%', aspectRatio: '3/1', objectFit: 'contain', padding: '15px' }}>
                  <img src="/assets/brand-myntra.png" alt="myntra" className='w-100' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                </div>
              </a>
            </div>
            <div className="col-md-3 p-1 col-6">
              <a href="https://www.pepperfry.com/product/blue-ceramic-speckle-floral-decorative-plate-2063568.html" className="nav-link">
                <div className='border border-brand-primary rounded-3' style={{ width: '100%', aspectRatio: '3/1', objectFit: 'contain', padding: '15px' }}>
                  <img src="/assets/brand-pepperfry.png" alt="pepperfry" className='w-100' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-5 collage-wrap">
          <img src="/assets/collage-1.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-2.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-3.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-4.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-5.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-6.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-7.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-8.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-9.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-10.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-11.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-12.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-13.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-14.jpeg" alt="" className="img-fluid" />
          <img src="/assets/collage-15.jpeg" alt="" className="img-fluid" />
        </div>
        <div className="mt-5 row">
          {/* 1️⃣ Shipping Faster */}
          <div className="col-md-3 d-flex flex-column align-items-center p-2">
            <i className="fi fi-rs-shipping-fast fs-1 text-brand-secondary"></i>
            <p className="mb-0 body-font-bold text-center">Free & Fast Shipping</p>
            <p className="mb-0 mt-1 body-font-light text-center fs-sm text-muted">
              We ensure swift and timely delivery to your doorstep, so you can enjoy your decor without delay.
            </p>
          </div>

          {/* 2️⃣ High Quality Products */}
          <div className="col-md-3 d-flex flex-column align-items-center p-2">
            <i className="fi fi-rs-badge-check fs-1 text-brand-secondary"></i>
            <p className="mb-0 body-font-bold text-center">Quality Products</p>
            <p className="mb-0 mt-1 body-font-light text-center fs-sm text-muted">
              Every product is crafted with superior materials and attention to detail, guaranteeing durability and a premium finish.
            </p>
          </div>

          {/* 3️⃣ Amazing Designs */}
          <div className="col-md-3 d-flex flex-column align-items-center p-2">
            <i className="fi fi-rs-sparkles fs-1 text-brand-secondary"></i>
            <p className="mb-0 body-font-bold text-center">Amazing Designs</p>
            <p className="mb-0 mt-1 body-font-light text-center fs-sm text-muted">
              Explore a unique collection of stylish, trendy, and elegant designs that uplift your living space.
            </p>
          </div>

          {/* 4️⃣ Safe Checkouts */}
          <div className="col-md-3 d-flex flex-column align-items-center p-2">
            <i className="fi fi-rs-lock fs-1 text-brand-secondary"></i>
            <p className="mb-0 body-font-bold text-center">Safe Checkouts</p>
            <p className="mb-0 mt-1 body-font-light text-center fs-sm text-muted">
              Shop with confidence with our fully secure and hassle-free online payment options.
            </p>
          </div>
        </div>

      </div>

      <div style={{ width: '100%', overflow: 'hidden' }}>
        <div className="scrolling-container mt-5">
          <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
          <img src="/assets/infinite-banner.jpg" alt="banner" className="scrolling-img" />
        </div>
      </div>

    </div>
  )
}

export default About